import { Markup } from "interweave";
import React from "react";
import "./LearniingDescription.css";

const LearningDescription = ({ learningSession }) => {
  return (
    <div className="auditionDes">
      <div className="p-3">

        <h1 className="titleInstruction d-flex justify-content-between text-center p-2 mt-2">
          <i class="fa-solid fa-calendar"></i>
          Learning Session Registration Date{" "}
          <i class="fa-solid fa-calendar"></i>
        </h1>
        <div className="titleInstructionCopy d-flex justify-content-center">
          <span className="lDate mx-2">
            {learningSession.assignment_reg_start_date &&
              new Date(
                learningSession.assignment_reg_start_date
              ).toLocaleDateString("en-US")}{" "}
          </span>
          To{" "}
          <span className=" mx-2 lDate">
            {learningSession.assignment_reg_end_date &&
              new Date(
                learningSession.assignment_reg_end_date
              ).toLocaleDateString("en-US")}
          </span>
        </div>
      </div>
      <div className="bottomLineGoldLearning"></div>
      <div className="p-3">
        <h2 className="fw-bold audiHeadTitle mb-3">{learningSession.title}</h2>
        <p className="text-light mx-3">
          <Markup content={learningSession.description} />
        </p>
      </div>
      <div className="bottomLineGold"></div>

      <div className="p-3">
        <h3 className="fw-bold audiHeadTitle my-3">
          Learning Session Instructions
        </h3>
        <p className="text-light">
          <Markup content={learningSession.assignment_instruction} />
        </p>
        {/* <div className="d-flex px-2 my-1">
          <img height="35px" src={auditionDescriptionIcon} alt="" />
          <p className="text-muted mx-2 descriptionPara">
           
          </p>
        </div> */}
      </div>
      <div className="bottomLineGold"></div>
    </div>
  );
};

export default LearningDescription;
